import React from 'react';
import { gatedSaleState } from '../../product/components/GatedSaleProductPrice/state';

export const Badge = ({
  badgeCopy,
  isDiscountBadge = false,
  showMemberGatedBadge = false,
}: {
  badgeCopy: string;
  isDiscountBadge?: boolean;
  showMemberGatedBadge?: boolean;
}) => {
  const { isEnabled: hardMarkSaleEnabled, badgeCopy: hardMarkSaleBadgeCopy } = gatedSaleState?.hardMarkSaleConfig ?? {};
  const saleBadge = hardMarkSaleEnabled && hardMarkSaleBadgeCopy ? hardMarkSaleBadgeCopy : 'Save';
  return (
    <div
      className={`product-card-badge ${isDiscountBadge ? 'discount-badge' : ''} ${
        showMemberGatedBadge ? 'member-gated' : hardMarkSaleEnabled ? 'hard-mark-sale' : ''
      }`}
    >
      {isDiscountBadge ? `${saleBadge} ${badgeCopy.replace(' Off', '')}` : badgeCopy}
    </div>
  );
};
